import { Observable } from 'rxjs';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { GalaxyAlertModule } from '@vendasta/galaxy/alert';
import { FormsModule } from '@angular/forms';
import { PipelineStatusCheckboxModule } from '../../pipelines/pipeline-status-checkbox/pipeline-status-checkbox.module';
import { PipelineSavedFiltersComponent } from './pipeline-saved-filters.component';
import { PipelineFilterDialogComponent } from './pipeline-table-filter-dialog/pipeline-filter-dialog.component';
import {
  HAS_ACCESS_TO_SAVE_FILTERS,
  PIPELINE_TABLE_SAVED_FILTERS_CONFIG_TOKEN,
  PipelineTableSavedFiltersConfig,
} from './tokens';
import { PipelineFiltersCacheModule } from '../pipeline-filters-cache/pipeline-filters-cache.module';

@NgModule({
  declarations: [PipelineSavedFiltersComponent, PipelineFilterDialogComponent],
  exports: [PipelineSavedFiltersComponent, PipelineFilterDialogComponent],
  imports: [
    CommonModule,
    TranslateModule,
    FormsModule,
    MatIconModule,
    MatButtonModule,
    MatMenuModule,
    MatInputModule,
    MatDialogModule,
    MatFormFieldModule,
    GalaxyAlertModule,
    PipelineStatusCheckboxModule,
    PipelineFiltersCacheModule,
  ],
  providers: [
    {
      provide: HAS_ACCESS_TO_SAVE_FILTERS,
      deps: [PIPELINE_TABLE_SAVED_FILTERS_CONFIG_TOKEN],
      useFactory: hasAccessToSaveFilters,
    },
  ],
})
export class PipelineSavedFiltersModule {}

function hasAccessToSaveFilters(config: PipelineTableSavedFiltersConfig): Observable<boolean> {
  return config.canAccessSaveFilters$;
}
